import {NotFoundComponent} from './not-found.component';


export const NotFoundRoutes = [
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: '**',
        redirectTo: '/404'
    },
];



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/not-found/not-found.routes.ts